import * as React from "react";
import { Redirect } from "react-router-dom";

const GotoEvents: React.FC = () => <Redirect to="/events" />;

export default GotoEvents;
